import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
var css = {
  "container": "oalp-qL52_",
  "bar": "oalp-2nbmq",
  "active": "oalp-223H5"
};
import cx from 'classnames';
var ProgressBarLine = function ProgressBarLine(_ref) {
  var metadata = _ref.metadata;
  var _ref2 = metadata || {},
    _ref2$noOfSteps = _ref2.noOfSteps,
    noOfSteps = _ref2$noOfSteps === void 0 ? 0 : _ref2$noOfSteps,
    _ref2$currentStep = _ref2.currentStep,
    currentStep = _ref2$currentStep === void 0 ? 1 : _ref2$currentStep;
  return noOfSteps > 0 ? /*#__PURE__*/React.createElement("div", {
    className: css.container
  }, _toConsumableArray(Array(noOfSteps).keys()).map(function (_, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css.bar, _defineProperty({}, css.active, index < currentStep))
    });
  })) : null;
};
export default ProgressBarLine;